import classNames from 'classnames';
import Image from 'next/image';

import { Ranking } from '@/icons/index';

import SectionTitle from '../SectionTitle/SectionTitle';
import TextBlock from '../TextBlock/TextBlock';
import List from '../List/List';

import styles from './ReverseBlock.module.scss';

const ReverseBlock = ({ data, className }) => {
  const renderLiItem = (item, index) => {
    return (
      <li
        className={styles['reverse-item__list-element']}
        key={index}
        itemScope
        itemType='https://schema.org/ListItem'
      >
        {item.text}
      </li>
    );
  };

  const renderReverseItem = (item, index) => {
    return (
      <div
        className={styles['reverse-item']}
        key={index}
        itemScope
        itemType='https://schema.org/ListItem'
      >
        <div className={styles['reverse-item__inner']}>
          {item?.title && (
            <SectionTitle
              titleModify={classNames([
                styles['reverse-item__title'],
                'title--medium',
              ])}
            >
              {item?.title}
            </SectionTitle>
          )}
          <div className={styles['reverse-item__content']}>
            {item?.top_text && (
              <TextBlock
                className={classNames([
                  styles['reverse-item__text'],
                  'text--medium',
                ])}
              >
                {item?.top_text}
              </TextBlock>
            )}
            {Boolean(item?.items?.length) && (
              <List>{item?.items?.map(renderLiItem)}</List>
            )}
          </div>
        </div>
        {item?.image && (
          <div className={styles['reverse-item__img-wrap']}>
            <Image
              className={styles['reverse-item__img']}
              src={item?.image}
              alt={item?.title}
              title={item?.title}
              loading='lazy'
              layout='fill'
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <section
      className={classNames(styles['reverse-block'], className)}
      itemScope
      itemType='https://schema.org/ItemList'
    >
      {data?.text && (
        <SectionTitle
          className={classNames(styles['reverse-block__title'], 'title--large')}
          Icon={Ranking}
          isHtml
        >
          {data?.text}
        </SectionTitle>
      )}
      {data?.items && (
        <div className={styles['reverse-block__inner']}>
          {data?.items?.map(renderReverseItem)}
        </div>
      )}
    </section>
  );
};

export default ReverseBlock;
